import { useEffect, useState } from "react";
import { lddGlobalSessionInfo, NavObjectType } from "../navigationTypes";
import { Modal, Button, Row, Col, Container } from "react-bootstrap";
import styles from "./marketingCheck.module.scss";


const pubURL = "https://docs.google.com/spreadsheets/d/1ABPhoYtnj4Fb-EXqazuhZa4Umr97ZRCG0C1cmjXJ4XM/gviz/tq?tqx=out:json&tq&gid=555302397"


namespace MarketingCheck {

    export type spreadSheetObj = {
        status: string,
        dataInfo: any
    };

    export type adObject = {
        ok: boolean,
        id: number,
        headline: string,
        blurb: string,
        learnMoreUrl: string,
        imageUrl: string,
        priority: number,
        date: string,
        max_age: string,
        sites: string[]
    };

    export function MarketingPopup(props: { info: lddGlobalSessionInfo, page: NavObjectType, dataRootContainer: any }) {
        const [tableData, setData] = useState<spreadSheetObj>({ status: "fail", dataInfo: null });
        const [tableLoaded, setLoaded] = useState(false);
        const [show, setShow] = useState(false);
        const [content, setContent] = useState({ headline: "", learnMoreUrl: "", blurb: "", imageUrl: "" });
        const [cookieData, setCookieData] = useState({ id: -1, date: "", max_age: "0", sites: [] });
        const handleClose = () => {
            let domain = '';
            if (window.location.href.indexOf("https") !== -1) {
                domain = window.location.href.substring(8, window.location.href.indexOf('/', 8));
            } else {
                domain = window.location.href.substring(7, window.location.href.indexOf('/', 7));
            }
            document.cookie = "adCookie" + cookieData.id + "=" + encodeURI(JSON.stringify(cookieData)) + ";Max-Age=" + parseInt(cookieData.max_age) * 60 * 60 * 24 + ";Domain=" + domain + ";Path=/";
            setShow(false)
        };

        let info = null;

        useEffect(() => {
            let getData = async () => {
                try {
                    let data = await fetch(pubURL);
                    let text = await data.text();
                    const jsonString = text.substring(47).slice(0, -2);
                    var json = JSON.parse(jsonString);
                    setData({ status: "ok", dataInfo: json });
                    setLoaded(true);
                } catch (e) {
                    console.log("Spreadsheet read error" + e);
                }
            }
            getData();

        }, []);
        useEffect(() => {
            if (tableLoaded) {
                if (props?.page?.component === "filelist" || props?.page?.component === "dr") {
                    info = checkData(tableData, props.info?.appCode).then(data => {
                        data.sort((a: adObject, b: adObject) => { if (a.priority < b.priority) { return -1 } else { return 1 } });
                        let adData = { ok: false, id: -1, headline: "", learnMoreUrl: "", imageUrl: "", blurb: "", priority: -1, date: "", max_age: "", sites: [] };
                        if (data.length > 0) {
                            adData = data.shift();
                            setCookieData({ id: adData.id, date: adData.date, max_age: adData.max_age, sites: adData.sites });
                        }

                        setShow(adData.ok);
                        setContent({ headline: adData.headline, learnMoreUrl: adData.learnMoreUrl, imageUrl: adData.imageUrl, blurb: adData.blurb });
                    });

                }
            }
        }, [props, tableLoaded, info]);

        return (<>
            <Modal show={show} onHide={handleClose} size="lg" centered className={styles.marketingModal + " modal-list"} backdrop={'static'}>
                <Modal.Body className={styles.imageContainer}>
                    <img src={content.imageUrl} className={styles.image} />
                </Modal.Body>

                <Modal.Footer>
                    <Container className="gx-0">
                        <Row className="gx-0">
                            <Col xs={8}>
                                <h3 className={styles.headline}>{content.headline}</h3>
                                <p className={styles.blurb}>{content.blurb}</p>
                            </Col>
                            <Col xs={4} className="align-right">
                                {content.learnMoreUrl === "" || content.learnMoreUrl === null ? <></> : <Button variant="primary" onClick={() => { window.open(content.learnMoreUrl) }}>Learn More</Button>}
                                <Button onClick={handleClose} variant="outline-primary">Dismiss</Button>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Footer>
            </Modal></>);
    }

    async function checkData(data: spreadSheetObj, appCode: string): Promise<adObject[]> {
        const currDate = Date.now();
        if (data.status === "fail") {
            throw Error("Market Spreadsheet failure");
        }
        let rows = data.dataInfo.table.rows;
        let userCookies = document.cookie;

        let adCookies = userCookies.split(';').filter((a) => a.trim().startsWith("adCookie"));
        let cookieTable = {};

        for (let i of adCookies) {
            let val = JSON.parse(decodeURI(i).split('=')[1]);
            if (val && ("id" in val && (val.id == 0 || ("date" in val && "sites" in val)))) {
                cookieTable[val.id] = val;
            }
        }

        //gets list of viable ads to display
        let ads_to_display = [];
        var siteCodes = { "uat": "uat", "beta": process.env.REACT_APP_BETASITE_URL, "live":  process.env.REACT_APP_LIVESITE_URL };
        for (let i of rows) {
            try {
                if (Date.parse(i.c[1].f) > currDate) {
                    continue;
                }
                if (i.c[2] !== null) {
                    if (Date.parse(i.c[2].f) < currDate) {
                        continue;
                    }
                }
                if (!i.c[3].v.split('|').includes(appCode)) {
                    continue;
                }
                if (i.c[0].v in cookieTable) {
                    if (Math.floor((currDate - Date.parse(cookieTable[i.c[0].v].date)) / (1000 * 60 * 60 * 24)) < parseInt(i.c[10].v)) {
                        continue;
                    }
                    if (cookieTable[i.c[0].v].sites.indexOf(appCode) !== -1) {
                        continue;
                    }
                }

                if (!(window.location.href.toLowerCase().includes(siteCodes[i.c[8].v]) || window.location.href.includes("devdocker"))) {
                    continue;
                }

                //manually reissue cookie incase browser doesnt delete
                let newVal = { id: i.c[0].v, date: cookieTable[i.c[0].v] };
                if (!newVal.date || Math.floor((currDate - Date.parse(newVal.date)) / (1000 * 60 * 60 * 24)) >= parseInt(i.c[10].v)) {
                    newVal.date = new Date().toDateString();
                }
                ads_to_display.push({
                    ok: true, id: i.c[0].v,
                    headline: i.c[4].v,
                    blurb: i.c[5] !== null ? i.c[5].v : "",
                    learnMoreUrl: i.c[6] !== null ? i.c[6].v : "",
                    imageUrl: i.c[7] !== null ? await saveMarketingImage(i.c[7].v) : "", priority: i.c[9].v, date: newVal.date, max_age: i.c[10].v, sites: i.c[3].v
                });
            } catch (error) {
                if (i.c[0] === null) {
                    console.log("Error, missing id");
                } else {
                    console.log("Error with popup " + i.c[0].v);
                }

            }

        }

        return ads_to_display;
    }
    async function saveMarketingImage(imageUrl: string) {
        var image;
        try {
            let fetchUrl = imageUrl;
            var download = await fetch(fetchUrl);
            if (imageUrl.indexOf("drive.google") !== -1 && imageUrl.indexOf('drive-viewer') === -1) {
                var temp = await download.text();
                let driveUrl = temp.substring(temp.indexOf("https://drive.google.com/drive-viewer/"), temp.indexOf("\"", temp.indexOf("https://drive.google.com/drive-viewer/")));
                download = await fetch(driveUrl.replace("\\u003d", "="));
            }
            
            image = URL.createObjectURL(await download.blob());
        } catch (e) {
            image = imageUrl;            
        }
        
        
        return image;
    }
}


export default MarketingCheck;